<app-header></app-header>

<div class="body">
    <router-outlet></router-outlet>
</div>

<p-toast></p-toast>
